// داده‌های حوزه‌های کالا و خدمات دانش‌بنیان
export const knowledgeBasedCategories = [
  {
    id: '01',
    name: 'کشاورزی، فناوری زیستی و صنایع غذایی',
    technologies: [
      {
        id: '01-01',
        name: 'مواد اولیه و فرمولاسیون غذایی',
        description: 'تولید و فرآوری مواد غذایی و فرمولاسیون‌های تخصصی'
      },
      {
        id: '01-02',
        name: 'حوزه تولیدات گیاهی',
        description: 'فناوری‌های مرتبط با کشت و تولید محصولات گیاهی'
      },
      {
        id: '01-03',
        name: 'حوزه تولیدات دام، طیور، آبزیان، زنبور عسل و گرده‌افشان',
        description: 'دامپروری، پرورش طیور و آبزیان'
      },
      {
        id: '01-04',
        name: 'محصولات مبتنی بر میکرورگانیسمی',
        description: 'محصولات بیولوژیک و میکروبی'
      }
    ]
  },
  {
    id: '02',
    name: 'دارو و فرآورده‌های پیشرفته',
    technologies: [
      {
        id: '02-01',
        name: 'حوزه تشخیص و درمان',
        description: 'تجهیزات و روش‌های تشخیص و درمان'
      },
      {
        id: '02-02',
        name: 'تولید مواد اولیه سنتتیک دارویی و مکمل',
        description: 'مواد موثره، اکسپیان و استاندارد'
      },
      {
        id: '02-03',
        name: 'فرمولاسیون‌های پیشرفته دارویی، مکمل‌ها و آرایشی بهداشتی',
        description: 'داروسازی و محصولات بهداشتی'
      },
      {
        id: '02-04',
        name: 'داروها، فرآورده‌ها و خدمات زیستی و تشخیصی',
        description: 'محصولات بیوتکنولوژی'
      },
      {
        id: '02-05',
        name: 'داروهای گیاهی',
        description: 'فرآورده‌های گیاهی و طبیعی'
      }
    ]
  },
  {
    id: '03',
    name: 'مواد پیشرفته و محصولات مبتنی بر فناوری‌های شیمیایی',
    technologies: [
      {
        id: '03-01',
        name: 'محصولات مبتنی بر فناوری‌های شیمیایی',
        description: 'مواد شیمیایی تخصصی و پیشرفته'
      },
      {
        id: '03-02',
        name: 'مواد پیشرفته (پلیمرها و کامپوزیت‌ها)',
        description: 'پلیمرها و مواد کامپوزیتی'
      },
      {
        id: '03-03',
        name: 'بسته‌های دانش فنی',
        description: 'دانش فنی صنایع شیمیایی'
      },
      {
        id: '03-04',
        name: 'واحدهای پالایشی و پتروشیمی',
        description: 'فناوری‌های پالایشگاهی'
      },
      {
        id: '03-05',
        name: 'فناوری نانو',
        description: 'نانومواد و نانوفناوری'
      },
      {
        id: '03-06',
        name: 'مواد پیشرفته (سرامیک‌ها و فلزات)',
        description: 'مواد سرامیکی و فلزی پیشرفته'
      }
    ]
  },
  {
    id: '04',
    name: 'ماشین‌آلات و تجهیزات پیشرفته',
    technologies: [
      {
        id: '04-01',
        name: 'تجهیزات ساخت و تولید مواد و قطعات فلزی، سرامیکی، پلیمری و کامپوزیتی',
        description: 'ماشین‌آلات تولید'
      },
      {
        id: '04-02',
        name: 'تجهیزات اختصاصی تولید نانومواد',
        description: 'دستگاه‌های نانوتکنولوژی'
      },
      {
        id: '04-03',
        name: 'ماشین‌های دوار و تجهیزات وابسته',
        description: 'توربین‌ها و کمپرسورها'
      },
      {
        id: '04-04',
        name: 'ماشین‌آلات و تجهیزات پیشرفته صنعت نفت و گاز',
        description: 'تجهیزات صنایع نفت'
      },
      {
        id: '04-05',
        name: 'تجهیزات پیشرفته حوزه انرژی‌های تجدیدپذیر',
        description: 'تجهیزات خورشیدی و بادی'
      },
      {
        id: '04-06',
        name: 'تجهیزات پیشرفته هسته‌ای',
        description: 'فناوری هسته‌ای'
      },
      {
        id: '04-07',
        name: 'هواگردها، تجهیزات و سازه‌های هوافضا',
        description: 'صنایع هوافضا'
      },
      {
        id: '04-08',
        name: 'سامانه‌ها، تجهیزات و عملگرهای پیشرفته هیدرولیکی و پنوماتیکی',
        description: 'سیستم‌های قدرت سیال'
      },
      {
        id: '04-09',
        name: 'شبیه‌سازهای پیشرفته',
        description: 'سیستم‌های شبیه‌سازی'
      },
      {
        id: '04-10',
        name: 'تجهیزات پیشرفته سایر حوزه‌ها',
        description: 'تجهیزات تخصصی متفرقه'
      },
      {
        id: '04-11',
        name: 'خدمات آزمایشگاهی و طراحی مهندسی',
        description: 'خدمات مهندسی تخصصی'
      },
      {
        id: '04-12',
        name: 'تجهیزات آزمایشگاهی و تجهیزات تست و آزمون',
        description: 'کنترل کیفی و آزمون'
      }
    ]
  },
  {
    id: '05',
    name: 'وسایل، ملزومات و تجهیزات پزشکی',
    technologies: [
      {
        id: '05-01',
        name: 'تجهیزات و ملزومات پزشکی',
        description: 'تجهیزات پزشکی عمومی'
      },
      {
        id: '05-02',
        name: 'تجهیزات، مواد و ملزومات دندان‌پزشکی',
        description: 'محصولات دندانپزشکی'
      },
      {
        id: '05-03',
        name: 'تجهیزات و مواد آزمایشگاه طبی',
        description: 'آزمایشگاه‌های تشخیص طبی'
      },
      {
        id: '05-04',
        name: 'تجهیزات بیمارستانی',
        description: 'تجهیزات و ملزومات بیمارستان'
      },
      {
        id: '05-05',
        name: 'تجهیزات پیشرفته آزمون کالیبراسیون تجهیزات پزشکی',
        description: 'کالیبراسیون و تست تجهیزات'
      }
    ]
  },
  {
    id: '06',
    name: 'سخت‌افزارهای برق و الکترونیک، لیزر و فوتونیک',
    technologies: [
      {
        id: '06-01',
        name: 'سخت‌افزارهای الکترونیکی و رایانه‌ای',
        description: 'قطعات الکترونیکی'
      },
      {
        id: '06-02',
        name: 'میکروالکترونیک',
        description: 'مدارات مجتمع و تراشه‌ها'
      },
      {
        id: '06-03',
        name: 'مدارهای الکترونیکی',
        description: 'برد و مدارات الکترونیکی'
      },
      {
        id: '06-04',
        name: 'تولید، انتقال، توزیع',
        description: 'سیستم‌های قدرت'
      },
      {
        id: '06-05',
        name: 'ماشین‌های الکتریکی',
        description: 'موتورها و ژنراتورها'
      },
      {
        id: '06-06',
        name: 'الکترونیک قدرت',
        description: 'مبدل‌ها و اینورترها'
      },
      {
        id: '06-07',
        name: 'اندازه‌گیری و ابزار دقیق',
        description: 'سنسورها و ابزار دقیق'
      },
      {
        id: '06-08',
        name: 'سامانه‌های کنترل و اتوماسیون صنعتی',
        description: 'سیستم‌های کنترل PLC و SCADA'
      },
      {
        id: '06-09',
        name: 'تجهیزات ارتباطی، مخابراتی، اپتیک و هوافضا',
        description: 'سیستم‌های مخابراتی'
      },
      {
        id: '06-10',
        name: 'لیزر و فوتونیک',
        description: 'دستگاه‌های لیزری و فوتونیک'
      }
    ]
  },
  {
    id: '07',
    name: 'فناوری اطلاعات و ارتباطات و نرم‌افزارهای رایانه‌ای',
    technologies: [
      {
        id: '07-01',
        name: 'برنامه‌های کاربردی',
        description: 'نرم‌افزارهای کاربردی و موبایل'
      },
      {
        id: '07-02',
        name: 'پلتفرم',
        description: 'پلتفرم‌های نرم‌افزاری'
      },
      {
        id: '07-03',
        name: 'زیرساخت',
        description: 'زیرساخت IT و شبکه'
      },
      {
        id: '07-04',
        name: 'امنیت فضای تبادل اطلاعات',
        description: 'امنیت سایبری'
      },
      {
        id: '07-05',
        name: 'صنعت انیمیشن و بازی‌های ویدیویی',
        description: 'گیم و انیمیشن'
      }
    ]
  },
  {
    id: '08',
    name: 'خدمات تجاری‌سازی',
    technologies: [
      {
        id: '08-01',
        name: 'خدمات ارزیابی',
        description: 'ارزیابی فناوری و کسب‌وکار'
      },
      {
        id: '08-02',
        name: 'خدمات حقوقی و مالکیت فکری',
        description: 'ثبت اختراع و مالکیت فکری'
      },
      {
        id: '08-03',
        name: 'خدمات تبادل فناوری',
        description: 'انتقال فناوری'
      },
      {
        id: '08-04',
        name: 'خدمات توسعه بازار',
        description: 'بازاریابی و فروش'
      },
      {
        id: '08-05',
        name: 'خدمات مالی و سرمایه‌گذاری',
        description: 'تامین مالی و سرمایه'
      },
      {
        id: '08-06',
        name: 'خدمات مدیریت فناوری و کسب وکار',
        description: 'مشاوره مدیریت'
      },
      {
        id: '08-07',
        name: 'شتابدهی و توسعه‌گری نواحی نوآوری',
        description: 'شتابدهنده و مرکز رشد'
      },
      {
        id: '08-08',
        name: 'خدمات سیاست‌گذاری',
        description: 'مشاوره سیاستی'
      }
    ]
  },
  {
    id: '09',
    name: 'صنایع فرهنگی، صنایع خلاق و علوم انسانی و اجتماعی',
    technologies: [
      {
        id: '09-01',
        name: 'علوم و ارتباطات',
        description: 'ارتباطات و رسانه'
      },
      {
        id: '09-02',
        name: 'رسانه',
        description: 'رسانه‌های دیجیتال'
      },
      {
        id: '09-03',
        name: 'علوم تربیتی و روانشناسی',
        description: 'آموزش و روانشناسی'
      },
      {
        id: '09-04',
        name: 'علوم آموزشی',
        description: 'محتوای آموزشی'
      },
      {
        id: '09-05',
        name: 'مدیریت و سیاستگذاری',
        description: 'مدیریت عمومی'
      },
      {
        id: '09-06',
        name: 'اقتصاد',
        description: 'اقتصاد و مالی'
      },
      {
        id: '09-07',
        name: 'مالی',
        description: 'خدمات مالی'
      },
      {
        id: '09-08',
        name: 'حقوق',
        description: 'خدمات حقوقی'
      }
    ]
  }
];
